export default function OptimizerFeatures() {
  const features = [
    {
      icon: 'ri-settings-3-line',
      title: '自定义设置选项',
      description: '根据您的移动端和桌面端查看需求进行精确配置,灵活控制优化参数以达到最佳效果。'
    },
    {
      icon: 'ri-archive-line',
      title: '长期保存',
      description: '遵循PDF/A归档标准进行文档存储,确保文档的长期可访问性和完整性。'
    },
    {
      icon: 'ri-palette-line',
      title: '真实色彩管理',
      description: '为您的理想目标媒介和应用提供精确的颜色转换,保持色彩的一致性和准确性。'
    },
    {
      icon: 'ri-stack-line',
      title: '批量处理',
      description: '通过集成到现有工作流程中实现PDF压缩自动化,大幅提升处理效率。'
    },
    {
      icon: 'ri-image-line',
      title: '图像处理',
      description: '在保持图像保真度的同时降低图像分辨率和文件大小,实现质量与体积的完美平衡。'
    },
    {
      icon: 'ri-file-reduce-line',
      title: '扁平化透明度',
      description: '优化扁平化文档并提高文档可移植性,确保在不同平台上的一致显示。'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            提升PDF性能
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            提升PDF性能不仅仅是关于文件大小,PDF Optimizer命令行工具让您能够针对各种工作流程优化文档。精细调整图像压缩选项,确定要保留或丢弃的内容以减少处理时间。文档将下载更快,无论在何种设备上都能轻松打开,打印和归档更加高效。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-gray-50 hover:bg-gradient-to-br hover:from-teal-50 hover:to-cyan-50 rounded-2xl p-8 transition-all duration-300 hover:shadow-xl border border-gray-100 hover:border-teal-200"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
